// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Work Sans', 'Work Sans Fallback'","fontStyle":"normal"},"className":"__className_cd2785","variable":"__variable_cd2785"};